import { FileText, Layers, Sparkles, type LucideIcon } from 'lucide-react';

export const SEARCH = {
  SUGGESTION_DEBOUNCE_MS: 250,
  QUERY_DEBOUNCE_MS: 300,
  SUGGESTION_LIMIT: 5,
  RECENT_SEARCH_LIMIT: 10,
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZES: [10, 20, 50] as const,
} as const;

export interface SearchTypeOption {
  value: 'basic' | 'semantic' | 'exact';
  labelKey: string;
  descriptionKey: string;
  icon: LucideIcon;
}

export const SEARCH_TYPES: SearchTypeOption[] = [
  { value: 'basic', labelKey: 'search.types.basic', descriptionKey: 'search.types.basicHint', icon: FileText },
  { value: 'semantic', labelKey: 'search.types.semantic', descriptionKey: 'search.types.semanticHint', icon: Sparkles },
  { value: 'exact', labelKey: 'search.types.exact', descriptionKey: 'search.types.exactHint', icon: Layers },
];

export const SEARCH_SORT_OPTIONS = [
  { value: 'relevance', labelKey: 'search.sort.relevance' },
  { value: 'date', labelKey: 'search.sort.date' },
  { value: 'title', labelKey: 'search.sort.title' },
] as const;
